import { FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { fontStack } from "../../themes/default";
import useGlobal from "../../util/Global";

export const CustomRadioGroup = ({ control, errors }) => {

    const [isIdari, setIsIdari] = useState(true);

    const { t } = useGlobal();

    const tenant = {
        acceptCandidate: {
            link_title: t('tenant.acceptCandidate_linkTitle'),
            description: t('tenant.acceptCandidate_description'),
            action: t('tenant.acceptCandidate_action'),
            link: t('tenant.acceptCandidate_link')
        },
        fieldCandidate: {
            link_title: t('tenant.fieldCandidate_linkTitle'),
            description: t('tenant.fieldCandidate_description'),
            action: t('tenant.fieldCandidate_action'),
            link: t('tenant.fieldCandidate_link')
        },
    };


    const UnderLine = ({ text }) => (
        <span style={{ textDecoration: "underline", color: "#798D9E", marginLeft: 5 }}>{text}</span>
    );

    const RadioLabel = ({ children }) => (
        <Typography variant="inherit" color={"text.primary"} sx={{ pt: 3, fontFamily: fontStack, fontSize: '0.8rem' }}>
            {children}
        </Typography>);


    const acceptLable = <RadioLabel>
        <>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={tenant.acceptCandidate.link}
                style={{ textDecoration: "noopener" }}
            >
                {tenant.acceptCandidate.link_title}
            </a>

        </>

        {tenant.acceptCandidate.description}

        <UnderLine text={tenant.acceptCandidate.action} />
    </RadioLabel>

    const rejectLabel = <RadioLabel>
        <>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={tenant.fieldCandidate.link}
                style={{ textDecoration: "noopener" }}
            >
                {tenant.fieldCandidate.title}
            </a>

        </>
        {tenant.fieldCandidate.description}

        <UnderLine text={tenant.fieldCandidate.action} />
    </RadioLabel>;

    return (<div style={{ marginTop: 16 }}>
        <Controller
            name="consent"
            control={control}
            rules={{ required: "Lütfen bir seçim yapın" }}
            render={({ field }) => (
                <RadioGroup {...field}>
                    <FormControlLabel
                        value="accept"
                        control={<Radio />}
                        label={acceptLable}
                    />
                    <FormControlLabel
                        value="reject"
                        control={<Radio />}
                        label={rejectLabel} />
                </RadioGroup>
            )}
        />
        {errors.consent && <FormHelperText error>{errors.consent.message}</FormHelperText>}
    </div>);
};